"use client";

import Cookies from "js-cookie";
import { LOCATION_OVERRIDE_COOKIE, USER_LOCATION_COOKIE } from "./constants";

const getUserCountryFromClient = (): string | null => {
  return (
    Cookies.get(LOCATION_OVERRIDE_COOKIE) ||
    Cookies.get(USER_LOCATION_COOKIE) ||
    null
  );
};

export default getUserCountryFromClient;
